export default [
    'box-shadow: inset 0px 0px 0px      rgb(119,188,239, 0.5), inset 0px 0px 0px    rgba(0,0,0,0.1);',
    'box-shadow: inset -1px -1px 2px    rgb(119,188,239, 0.5), inset 1px 1px 2px    rgba(0,0,0,0.1);',
    'box-shadow: inset -2px -2px 4px    rgb(119,188,239, 0.5), inset 2px 2px 4px    rgba(0,0,0,0.1);',
    'box-shadow: inset -4px -4px 6px    rgb(119,188,239, 0.5), inset 4px 4px 6px    rgba(0,0,0,0.1);',    
    'box-shadow: inset -6px -6px 8px    rgb(119,188,239, 0.5), inset 6px 6px 8px    rgba(0,0,0,0.1);',
    'box-shadow: inset -8px -8px 10px   rgb(119,188,239, 0.5), inset 8px 8px 10px   rgba(0,0,0,0.1);'    
];
